import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import it from '../locale/it'
import moment from 'moment'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
	  resources: {
	    "it-IT": it
	  },
	  fallbackLng: "it-IT",
	  debug: false,
	  lng: 'it-IT',
	  whitelist: ['it-IT'],

	  ns: ["translations"],
	  defaultNS: "translations",

	  keySeparator: '.',

	  interpolation: {
	    escapeValue: false,

	    format: function(value, format, lng) {
		    if(format === 'date')
		      return moment(value).format("DD/MM/YYYY")
		    if(format === 'number')
		      return (value!=null ? parseFloat(value).toLocaleString(lng) : '-')
		    if(format === 'currency')
		      return (value!=null ? parseFloat(value).toLocaleString(lng, { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }) : '-')
		    if(format === 'percentage')
		      return (value!=null ? parseFloat(value).toLocaleString(lng, {style: 'percent', maximumFractionDigits: 2}) : '-')
		    if(format === 'percentage_100')
		      return (value!=null ? (parseFloat(value)/100).toLocaleString(lng, {style: 'percent', maximumFractionDigits: 2}) : '-')
		    return value;
      }
	  }
  });

export default i18n;
